<script lang="ts">
  import { DefaultTable, Layout, StatusTag } from "../../components";
  import { DataCell } from "@gl/design-system"
  import type { JobStatus } from "../../services/models"
  import { onDestroy, onMount } from "svelte"
  import { getJobsStatus } from "../../services/endpoints"
  import { navigateCustom } from "../../utils/navigateCustom"
  import { _ } from "svelte-i18n"
  import StatusInspector from "../../components/status/StatusInspector.svelte"
  
  let data: JobStatus[] = [];
  let loading = true;
  let limit = 10
  let offset = 0
  let totalCount = 0
  let searchText = ""
  let interval: NodeJS.Timeout;
  let inspector: any;
  let inspectorRowStatus: JobStatus;

  onMount(() => {
    search()
    interval = setInterval(() => {search(true)}, 10 * 1000)
  })

  onDestroy(() => {
    clearInterval(interval)
  })

  function search(runInBackground = false) {
    loading = !runInBackground
    getJobsStatus(limit, offset, searchText).then(jobs => {data = jobs.list; totalCount = jobs.meta.count; loading = false })
  }
</script>

<Layout selected="jobs">
  <DefaultTable
    title={ $_("common.jobs") }
    {data}
    {loading}
    bind:limit={limit}
    bind:offset={offset}
    bind:totalCount={totalCount}
    bind:searchText={searchText}
    on:search={search}
    let:row
    let:index >
    <DataCell {index} header="Name">{ row.title }</DataCell>
    <DataCell {index} header="UUID"><a on:mouseup={(e) => navigateCustom("/jobs/" + row.uuid, e)}>{ row.uuid }</a></DataCell>
    <DataCell {index} header="Status"><div style="cursor: pointer;" on:click={() => {inspectorRowStatus = row; inspector.open()}}><StatusTag status={row.status}></StatusTag></div></DataCell>
    <DataCell {index} header="Progress">{row.status.progress}</DataCell>
  </DefaultTable>

  <StatusInspector bind:inspector={inspector} bind:status={inspectorRowStatus}></StatusInspector>
</Layout>
